import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";
import { lightBlue } from "@mui/material/colors";

export const useStyles = makeStyles<Theme>((theme) => {
  const color = theme.palette.mode === "dark" ? lightBlue[50] : lightBlue[900];

  return {
    root: {
      alignItems: 'center',
      backgroundColor: theme.palette.mode === "dark" ? lightBlue[900] : lightBlue[50],
      '& .MuiAlert-icon': {
        color,
      },
      '& .MuiAlert-message': {
        color,
      },
      '& .MuiAlert-action': {
        alignItems: 'center',
        padding: '0 0 0 16px',
        marginRight: 0,
      },
    },

    withAction: {
      '@media (max-width: 767px)': {
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        gridTemplateAreas: '"icon action" "message message"',
        '& .MuiAlert-icon': {
          gridArea: 'icon',
        },
        '& .MuiAlert-action': {
          gridArea: 'action',
          justifyContent: 'flex-end',
          padding: 0,
        },
        '& .MuiAlert-message': {
          gridArea: 'message',
        },
      },
    },

    button: {
      whiteSpace: 'nowrap',
      color,
    },
  };
});
